import e, { css as i } from "styled-components";
import { Button as r } from "../../../Inputs/Button/Button.es.js";
import { Typography as a } from "../../../Typography/Typography.es.js";
const s = e(r).withConfig({
  displayName: "CloseButton",
  componentId: "sc-1po76t8-0"
})(["border-radius:26px;cursor:pointer;height:32px;margin-left:auto;:hover{background-color:var(--color-navy-50);}"]), n = e.div.withConfig({
  displayName: "HeaderTitle",
  componentId: "sc-1po76t8-1"
})(["align-items:center;display:flex;"]), m = e.div.withConfig({
  displayName: "Header",
  componentId: "sc-1po76t8-2"
})(["align-items:center;align-items:center;border-bottom:1px solid var(--color-gray-light2);display:flex;justify-content:space-between;min-height:56px;padding:12px 16px;", ""], ({
  hasStepBar: t
}) => {
  var o;
  return t && i(["display:grid;grid-template-columns:1fr 2fr 1fr;min-height:88px;", "{max-width:100%;overflow:hidden;word-break:break-word;}", "{-webkit-box-orient:vertical;-webkit-line-clamp:2;display:-webkit-box;max-width:100%;overflow:hidden;}"], n, (o = a.S) == null ? void 0 : o.Typography);
});
export {
  s as CloseButton,
  m as Header,
  n as HeaderTitle
};
//# sourceMappingURL=style.es.js.map
